import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

const ENDPOINT = '/eload-rewards';
const S3_FOLDER = 'eload-reward-documents';

export const state = {
  eloadRewards: [],
  eloadRewardsPage: {
    totalRows: 0
  },
  userList : [],
  userListPage: {
    totalRows: 0
  },
  errors: null
}

export const mutations = {
  UPDATE_USERS_LIST(state, userList){
    try {
      for(let x of userList){
        if(x.cognito_sub == null){
          x["$isDisabled"] = true;
        }
      } 
    } catch (error) {
      console.log("Update user list ERROR: ", error);
    }
    state.userList = userList;
  },
  UPDATE_USERS_LIST_PAGE(state, pageInfo){
    state.userListPage = pageInfo;
  },
  SET_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_ELOAD_REWARD_LIST(state, eloadRewards){
    state.eloadRewards = eloadRewards;
  },
  UPDATE_ELOAD_REWARD_PAGE(state, pageInfo){
    state.eloadRewardsPage = pageInfo;
  },
}

export const actions = {
  getAllUsers(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${ENDPOINT}/get-users`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_USERS_LIST', data.message.rows);
            context.commit('UPDATE_USERS_LIST_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  createReward(context, params){
      return new Promise((resolve, reject) => {
          API.post(`${ENDPOINT}/create-rewardv3`, params)
          .then(({ data }) => {
              if(data.status === "ok") {
                  resolve(data.message);
              } else {
                  reject(data.message)
              }
          })
          .catch(({ response }) => {
              context.commit('SET_ERROR', response.data.errors);
              reject(response);
          });
      });
  },
  eloadRewardList(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${ENDPOINT}/eload-rewards-listv3`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_ELOAD_REWARD_LIST', data.message.rows);
            context.commit('UPDATE_ELOAD_REWARD_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  rewardApproves(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${ENDPOINT}/actionv3`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  actionEloadReward(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  fetchUserDetails(context, userData){
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}/get-user-details`, {
        users: userData
      })
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  //supporting document
  uploadSupportingDocument(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg","csv","xlsx","vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      if(params.type == 'csv'){
        metadata['contentType'] = 'text/csv';
      }
      if(params.type == 'xlsx'){
        metadata['contentType'] = 'text/xlsx';
      }
      if(params.type == "vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        metadata['contentType'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        let name = params.filename.split(".");
        params.filename = name[0]+ ".xlsx";
      }
      // console.log(">>>>>>>",metadata['contentType']);
      Storage.put(`${S3_FOLDER}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);

            resolve(stored.key.replace(params.folder + "/", ""));
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  }
}

export const getters = {}